<template>
  <div id="campaign-animation" class="c-campaign-animation">
    <div class="text">
      <img class="anim-1" src="/assets/images/campaign/lottery-1.svg" alt="">
      <img class="anim-2" src="/assets/images/campaign/lottery-2.svg" alt="">
      <img class="anim-3" src="/assets/images/campaign/lottery-3.svg" alt="">
    </div>
    <div class="animation">
      <img :src="currentImage" alt="">
    </div>
    <div class="stop-text">
      画面操作せずにお待ちください
    </div>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import dayjs from "dayjs";
import Vue from "vue";
const $ = window.$;

const img = [
  "/assets/images/campaign/lottery/8.png",
  "/assets/images/campaign/lottery/7.png",
  "/assets/images/campaign/lottery/6.png",
  "/assets/images/campaign/lottery/5.png",
  "/assets/images/campaign/lottery/4.png",
  "/assets/images/campaign/lottery/3.png",
  "/assets/images/campaign/lottery/2.png",
  "/assets/images/campaign/lottery/1.png"
]

const stopImg = [
  "/assets/images/campaign/lottery/stop1.png",
  "/assets/images/campaign/lottery/stop2.png",
  "/assets/images/campaign/lottery/stop3.png",
  "/assets/images/campaign/lottery/stop4.png"
]

let timeFunc = null;

export default Vue.extend({
  name: "CampaignAnimation",
  props: ['stopDisabled'],
  components: {
  },
  data () {
    return {
      currentNum: 0,
      currentImage: img[0],
      stoped:false,
      stopCurrentNum:0,
      spped:150,
      initTime: dayjs()
    }
  },
  async created () {
  },
  mounted () {
    window.addEventListener('popstate', this.popstateHook);
    timeFunc = setInterval(this.countUp, this.spped);
    
    var self = this
    setTimeout(function() {
      if (timeFunc) {
        self.stopButton()
      }
    }, 20000)
  },
  updated() {
  },
  computed: {
    isStopDisabled: function () {
      return this.stopDisabled
    }
  },
  watch: {
    isStopDisabled () {
      this.$nextTick(() => {
        if (!this.stopDisabled) {
          const now = dayjs();
          console.log('変更されました watch',this.stopDisabled,now.diff(this.initTime, 'millisecond'))
          const diff_millisecond = now.diff(this.initTime, 'millisecond');
          const disp_millisecond = 5000;
          if (diff_millisecond > disp_millisecond) {
            this.stopButton();
          } else {
            var self = this
            setTimeout(function() {
              self.stopButton();
            }, disp_millisecond - diff_millisecond);
          }
        }
      })
    }
  },
  methods: {
    endAnimation(){
      this.stopAnim()
      var self = this
      setTimeout(function() {
        self.$emit('add');
      },1000)
    },
    countUp(){
      if (this.stoped && this.currentNum == 7) {
        this.currentImage = stopImg[this.stopCurrentNum]
        this.stopCurrentNum++
        if (this.stopCurrentNum >= 3) {
          this.endAnimation()
        }
      } else {
        if (img.length <= this.currentNum) {
          this.currentNum = 0
          this.currentImage = stopImg[this.currentNum]
        } else {
          this.currentNum++
          if (img.length <= this.currentNum) {
            this.currentNum = 0    
          }
          this.currentImage = img[this.currentNum]
        }
      }
    },
    stopAnim() {
      console.log("stopAnim")
      if (timeFunc) {
        clearInterval(timeFunc);
        timeFunc = null
      }
      this.currentImage = img[0]
    },
    stopButton() {
      this.spped = 1200
      this.stoped = true
    },
    popstateHook(e) {
      history.pushState(null, null, null);
      console.log("KKKKKKKKKKKKK");
      console.log(e);
      //this.$router.replace('/campaign/list');
    }
  },
  beforeDestroy() {
    if (timeFunc) {
      clearInterval(timeFunc);
        timeFunc = null
    }
     window.removeEventListener('popstate', this.popstateHook);
  }
})
</script>
